import { Dynamic } from "solid-js/web";
import { useSolidNodeView } from "./useSolidNodeView";
export const NodeViewWrapper = (props) => {
    const { onDragStart } = useSolidNodeView();
    return (<Dynamic component={props.as || "div"} {...props} data-node-view-wrapper="" onDragStart={onDragStart} style={{
            ...props.style,
            whiteSpace: "normal",
        }}/>);
};
